module.exports = __webpack_public_path__ + "static/media/broadband.6c3f7b97.png";